// extracted by mini-css-extract-plugin
module.exports = {"viewport":"AnimatedHero-module--viewport--GV2sx"};